import React from 'react'
import QrCode from 'qrcode'
import clsx from 'clsx'

const Qr = ({ className, code, width = 140, margin = 0, isDarkTheme }) => {
   const [qr, setQr] = React.useState(null)

   React.useEffect(() => {
      ;(async () => {
         try {
            const url = await QrCode.toDataURL(code, {
               color: {
                  dark: '#000000',
                  light: isDarkTheme ? '#fff' : '#0000',
               },
               width,
               margin,
            })
            setQr(
               <img alt="QR Code" className={clsx('Qr', className)} src={url} />
            )
         } catch (err) {
            console.log(err)
         }
      })()
   }, [className, code, width, margin, isDarkTheme])

   return <>{qr}</>
}

export default Qr
